define('models/ProductBoostModel',['underscore', 'ObjectModel', 'app', 'formatPrice', 'sprintf', 'UrlFactory'],
    function (_, ObjectModel, app, formatPrice, sprintf, UrlFactory)
    {
        //
        // ProductBoost Model
        //

        var ProductBoostModelPrototype = {
            _p:function(_t){
                return app.getProduct(this.get(_t));
            },
            getSourceProduct:function(){
                return this._p('id_product_source');
            },
            getTargetProduct:function(){
                return this._p('id_product_target');
            },
            getTargetProductMapping:function(){
                return this._p('id_product_target_mapping');
            },
            getMenuType:function(){
                return parseInt(this.get('type')) || 0;
            },
            getMenuTypeSlug:function() {
                var menuType = this.getMenuType(),
                    slugs = ['Generic','Poke','Smart','Sando','Gourmet'];
                return slugs[menuType] || slugs[0];
            },
            getImageUrl:function() {
                var menuType = this.getMenuType();
                var url = '', id_picture = this.get('id_picture');
                if(menuType>0){
                    var image_dir = '/FRONTOFFICE/views/risingsun/medias/img/product-boost/';
                    url = image_dir + this.getMenuTypeSlug().toLowerCase() + '.svg';
                }
                if(id_picture){
                    url = UrlFactory.getUrlPicture(id_picture, "productboost", "320x240","boost","png");
                }
                return url;
            },
            getPriceDifference:function(){
                // fix float round value diff
                return Math.round(this.getTargetProduct().getPrice()*1000 - this.getSourceProduct().getPrice()*1000)/1000;
            },
            formatPriceDifference:function(options){
                var opt = _.defaults(options,{
                    ignore_space:true,
                    auto_round_decimal:true,
                }), diff = this.getPriceDifference();
                return formatPrice(diff,opt);
            },
            label:function(key){
                var model = this,
                    message = model.get(key);
                return sprintf.vsprintf(message,model.formatPriceDifference());
            },
            availableInContext:function(){
                // TODO gérer la disponibilité du produit de destination, dans le contexte.
                var model = this,
                    targetProduct = model.getTargetProduct(),
                    stores_exclusion = model.get('stores_exclusion'),
                    is_store_excluded = false,
                    id_store = app.getCart().get('id_store');
                if(id_store === '0'){
                    is_store_excluded = !!model.get('stores_exclusion_no_store');
                }else if(stores_exclusion > 0){
                    var stores_exclusion_ids = model.get('stores_exclusion_ids');
                    is_store_excluded = _.contains(stores_exclusion_ids,id_store);
                    if(stores_exclusion === 2) is_store_excluded = !is_store_excluded;
                }
                return !!targetProduct && targetProduct.isBuyableInContext() && !is_store_excluded;
            },
            requireProductBoost:function(sidedishModel){
                // TODO à finaliser
                var model = this,
                    id_cross_selling_trigger = model.get('id_cross_selling_trigger'),
                    validateCrossSelling;
                if(sidedishModel){
                    // affichage sur une étape de déclenchement de la fiche produit
                    validateCrossSelling = id_cross_selling_trigger === sidedishModel.id;
                }else{
                    // validation au moment de l'ajout du panier
                    validateCrossSelling = id_cross_selling_trigger === '0';
                }
                return validateCrossSelling && this.availableInContext();
            },
            applyBoostSelection:function(){
                var productBoostModel = this,
                    sourceProduct = productBoostModel.getSourceProduct(),
                    sourceProductIsMenu = sourceProduct.isMenu(),
                    targetProduct = productBoostModel.getTargetProduct(),
                    targetProductMapping = productBoostModel.getTargetProductMapping(),
                    initialSerializedSelection = '',
                    useProductMapping = false;
                targetProduct.resetSidedishes();

                function ApplyProductBoostMapping(sourceSidedish) {
                    var sourceCategory = sourceSidedish.getCategory();
                    var sourceSelection = sourceSidedish.get('selection');
                    if (sourceCategory) {
                        // si on a une catégorie produits (ça n'est pas le cas pour un cross-selling groupé)
                        targetProduct.getSidedishes().each(function ApplyMapping(targetSidedish) {
                            var targetCategory = targetSidedish.getCategory();
                            if (targetCategory) {
                                // si la catégorie correspond, on applique la même selection
                                if (targetCategory.id === sourceCategory.id && sourceProductIsMenu) {
                                    targetSidedish.set('selection', sourceSelection);
                                } else {
                                    // sinon on essaie de trouver une correspondance dans la catégorie…
                                    var targetIdProduct;
                                    // à partir de la liste de ses id_product
                                    var categoryProductsIds = targetSidedish.getCategoryProducts().pluck('id_product');

                                    if (targetProductMapping && _.contains(categoryProductsIds, targetProductMapping.id)) {
                                        // sinon, si il y a un mapping produit (targetProductMapping)
                                        // on fabrique une selection à partir de cet id_product
                                        targetIdProduct = targetProductMapping.id;
                                        useProductMapping = true;
                                    } else if (_.contains(categoryProductsIds, sourceProduct.id)) {
                                        // ou une équivalence du produit de base, (gestion automatique)
                                        targetIdProduct = sourceProduct.id;
                                        useProductMapping = true;
                                    }
                                    if (targetIdProduct) {
                                        targetSidedish.set('selection', [{
                                            id: targetIdProduct,
                                            quantity: 1
                                        }]);
                                    }
                                }
                            }
                        })
                    }
                }

                // mapping selection source -> target
                if(sourceProductIsMenu) {
                    sourceProduct.getSidedishes().each(ApplyProductBoostMapping)
                }else{
                    targetProduct.getSidedishes().each(ApplyProductBoostMapping)
                }
                initialSerializedSelection = targetProduct.getSidedishes().getSerializedSelection();
                targetProduct.set('initialSerializedSelection',initialSerializedSelection);
                targetProduct.set('useProductMapping',useProductMapping);
            }
        }

        var ProductBoostModel = ObjectModel.extend(ProductBoostModelPrototype);

        return ProductBoostModel;
    });
